export enum InfoboxTypeEnum {
  success = 'success',
  attention = 'attention',
  warning = 'warning',
}
